import { render, staticRenderFns } from "./AttentionInbox.vue?vue&type=template&id=d84406f2&scoped=true&"
import script from "./AttentionInbox.vue?vue&type=script&lang=js&"
export * from "./AttentionInbox.vue?vue&type=script&lang=js&"
import style0 from "./AttentionInbox.vue?vue&type=style&index=0&id=d84406f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84406f2",
  null
  
)

export default component.exports